// extracted by mini-css-extract-plugin
module.exports = {"container":"RectanglesChart_container__1fSFQ","tooltip":"RectanglesChart_tooltip__1xYw4","removeUser":"RectanglesChart_removeUser__1oKLC"};